import type { FC } from 'react'
import React from 'react'
import { JOURNAL_TAG_ATTRIBUTES } from '@/constants/journal'
import { BANNERS } from '@/pages/JournalPublication/components/PublicationText/constants'
import { getStaticImagePath } from '@/utils/images'
import type { IPublicationComponentProps } from '../types'

const { banner } = JOURNAL_TAG_ATTRIBUTES

export const PublicationBannerDeprecated: FC<IPublicationComponentProps> = props => {
  const { attribs } = props

  const parsedBannerName = attribs[banner.type]

  const bannerName =
    parsedBannerName && parsedBannerName in BANNERS
      ? BANNERS[parsedBannerName as keyof typeof BANNERS].name
      : BANNERS['AGRICULTURAL-PRODUCTS-BANNER'].name

  const bannerImage = getStaticImagePath(`journal/article/banners/${bannerName}.svg`)

  return (
    <div className="focusBlock publicationText__banner banner">
      <div className="banner__textWrapper">
        <div className="banner__heading">
          <p className="h4">{attribs[banner.title]}</p>
          <p>{attribs[banner.description]}</p>
        </div>
        <a className="button button_green banner__button" href={attribs[banner.link]} target="_blank" rel="noreferrer">
          {attribs[banner.buttonText]}
        </a>
      </div>
      <div className="banner__logo" style={{ backgroundImage: `url("${bannerImage}")` }} />
    </div>
  )
}
